import { render, staticRenderFns } from "./SDS-results.vue?vue&type=template&id=f88567c2"
import script from "./SDS-results.vue?vue&type=script&lang=js"
export * from "./SDS-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports